// @app/common/sidebar/duck/index.js
import navBarReducer from './reducers';
export { default as navBarOperations } from './operations';
export default navBarReducer;